/** @jsx jsx */
import { jsx } from "theme-ui"
import Text from './text'

const appFeatures = [
    'Share directions with friends',
    'Find nearby work around you',
    '“Collect” artwork to keep track of what you\'ve seen',
    'Get notified when you\'re near work you want to see',
]

function AppFeatures({light}: {light?: boolean;}) {
    return (
        <ul sx={{
            listStyleType: 'disc', 
            paddingLeft: '24px', 
            mb: 3,
            color: light ? 'primary' : 'text',
        }}>
            {appFeatures.map(feat => <li key={feat}><Text light={light}>{feat}</Text></li>)}
        </ul>
    )
}

export default AppFeatures